import * as React from "react";
import type { SVGProps } from "react";
const SvgPuzzleDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={13}
    fill="none"
    viewBox="0 0 14 13" {...props}
  >
    <path
      fill="#258695"
      d="M2.765 12.133H13.59a.4.4 0 0 0 .29-.124.43.43 0 0 0 .12-.299V.423a.43.43 0 0 0-.12-.299.4.4 0 0 0-.29-.124H9.424a.4.4 0 0 0-.222.067.435.435 0 0 0-.088.634l.025.03c.197.24.305.546.305.86 0 .731-.569 1.325-1.267 1.325s-1.266-.592-1.266-1.324c0-.323.113-.635.319-.879a.43.43 0 0 0 .076-.461.4.4 0 0 0-.154-.186A.4.4 0 0 0 6.924 0h-4.16a.4.4 0 0 0-.29.124.43.43 0 0 0-.12.3V3.45a2 2 0 0 0-.19-.009C.97 3.442 0 4.452 0 5.693s.97 2.251 2.163 2.251q.096 0 .192-.008v3.774c0 .112.043.22.12.3s.18.123.29.123"
    />
  </svg>
);
export default SvgPuzzleDark;
